import React from 'react';
import { FolderOutlined } from '@ant-design/icons';
import { getItem } from '../../util';

export const FE6Items = getItem('FE6', 'FE6', <FolderOutlined />, [
  getItem('Battle screen editor part 1', 'FE6/Battlescreeneditorpart1'),
  getItem('Battle screen editor part 2', 'FE6/Battlescreeneditorpart2'),
  getItem('Battle screen editor part 3', 'FE6/Battlescreeneditorpart3'),
  getItem('Battle screen editor part 4', 'FE6/Battlescreeneditorpart4'),
  getItem('Battle screen editor part 5', 'FE6/Battlescreeneditorpart5'),
  getItem('Chapter 1 Army Editor', 'FE6/Chapter1ArmyEditor'),
  getItem('Chapter 10A Army Editor', 'FE6/Chapter10AArmyEditor'),
  getItem('Chapter 10B Armory Editor', 'FE6/Chapter10BArmoryEditor'),
  getItem('Chapter 10B Army Editor', 'FE6/Chapter10BArmyEditor'),
  getItem('Chapter 10B Shop Events', 'FE6/Chapter10BShopEvents'),
  getItem('Chapter 11A Army Editor', 'FE6/Chapter11AArmyEditor'),
  getItem('Chapter 11A Shop Events', 'FE6/Chapter11AShopEvents'),
  getItem('Chapter 11B Army Editor', 'FE6/Chapter11BArmyEditor'),
  getItem('Chapter 11B Shop Events', 'FE6/Chapter11BShopEvents'),
  getItem('Chapter 12 Army Editor', 'FE6/Chapter12ArmyEditor'),
  getItem('Chapter 12x Army Editor', 'FE6/Chapter12xArmyEditor'),
  getItem('Chapter 13 Army Editor', 'FE6/Chapter13ArmyEditor'),
  getItem('Chapter 13 Shop Events', 'FE6/Chapter13ShopEvents'),
  getItem('Chapter 14 Army Editor', 'FE6/Chapter14ArmyEditor'),
  getItem('Chapter 14 Shop Events', 'FE6/Chapter14ShopEvents'),
  getItem('Chapter 14x Army Editor', 'FE6/Chapter14xArmyEditor'),
  getItem('Chapter 15 Army Editor', 'FE6/Chapter15ArmyEditor'),
  getItem('Chapter 15 Shop Events', 'FE6/Chapter15ShopEvents'),
  getItem('Chapter 16 Army Editor', 'FE6/Chapter16ArmyEditor'),
  getItem('Chapter 16 Shop Events', 'FE6/Chapter16ShopEvents'),
  getItem('Chapter 16x Army Editor', 'FE6/Chapter16xArmyEditor'),
  getItem('Chapter 17A Army Editor', 'FE6/Chapter17AArmyEditor'),
  getItem('Chapter 17A Shop Events', 'FE6/Chapter17AShopEvents'),
  getItem('Chapter 17B Army Editor', 'FE6/Chapter17BArmyEditor'),
  getItem('Chapter 17B Shop Events', 'FE6/Chapter17BShopEvents'),
  getItem('Chapter 18A Army Editor', 'FE6/Chapter18AArmyEditor'),
  getItem('Chapter 18B Army Editor', 'FE6/Chapter18BArmyEditor'),
  getItem('Chapter 18B Shop Events', 'FE6/Chapter18BShopEvents'),
  getItem('Chapter 19A Army Editor', 'FE6/Chapter19AArmyEditor'),
  getItem('Chapter 19A Shop Events', 'FE6/Chapter19AShopEvents'),
  getItem('Chapter 19B Army Editor', 'FE6/Chapter19BArmyEditor'),
  getItem('Chapter 19B Shop Events', 'FE6/Chapter19BShopEvents'),
  getItem('Chapter 2 Armory Editor', 'FE6/Chapter2ArmoryEditor'),
  getItem('Chapter 2 Army Editor', 'FE6/Chapter2ArmyEditor'),
  getItem('Chapter 2 Shop Events', 'FE6/Chapter2ShopEvents'),
  getItem('Chapter 2 Vendor Editor', 'FE6/Chapter2VendorEditor'),
  getItem('Chapter 20A Army Editor', 'FE6/Chapter20AArmyEditor'),
  getItem('Chapter 20A Shop Events', 'FE6/Chapter20AShopEvents'),
  getItem('Chapter 20Ax Army Editor', 'FE6/Chapter20AxArmyEditor'),
  getItem('Chapter 20B Army Editor', 'FE6/Chapter20BArmyEditor'),
  getItem('Chapter 20Bx Army Editor', 'FE6/Chapter20BxArmyEditor'),
  getItem('Chapter 21 Army Editor', 'FE6/Chapter21ArmyEditor'),
  getItem('Chapter 21 Shop Events', 'FE6/Chapter21ShopEvents'),
  getItem('Chapter 21x Army Editor', 'FE6/Chapter21xArmyEditor'),
  getItem('Chapter 22 Army Editor', 'FE6/Chapter22ArmyEditor'),
  getItem('Chapter 23 Army Editor', 'FE6/Chapter23ArmyEditor'),
  getItem('Chapter 23 Shop Events', 'FE6/Chapter23ShopEvents'),
  getItem('Chapter 24 Army Editor', 'FE6/Chapter24ArmyEditor'),
  getItem('Chapter 3 Army Editor', 'FE6/Chapter3ArmyEditor'),
  getItem('Chapter 4 Armory Editor', 'FE6/Chapter4ArmoryEditor'),
  getItem('Chapter 4 Army Editor', 'FE6/Chapter4ArmyEditor'),
  getItem('Chapter 4 Shop Events', 'FE6/Chapter4ShopEvents'),
  getItem('Chapter 4 Vendor Editor', 'FE6/Chapter4VendorEditor'),
  getItem('Chapter 5 Army Editor', 'FE6/Chapter5ArmyEditor'),
  getItem('Chapter 5 Shop Events', 'FE6/Chapter5ShopEvents'),
  getItem('Chapter 5 Vendor Editor', 'FE6/Chapter5VendorEditor'),
  getItem('Chapter 6 Army Editor', 'FE6/Chapter6ArmyEditor'),
  getItem('Chapter 7 Army Editor', 'FE6/Chapter7ArmyEditor'),
  getItem('Chapter 7 Left Armory Editor', 'FE6/Chapter7LeftArmoryEditor'),
  getItem('Chapter 7 Right Armory Editor', 'FE6/Chapter7RightArmoryEditor'),
  getItem('Chapter 7 Shop Events', 'FE6/Chapter7ShopEvents'),
  getItem('Chapter 7 Vendor Editor', 'FE6/Chapter7VendorEditor'),
  getItem('Chapter 8 Army Editor', 'FE6/Chapter8ArmyEditor'),
  getItem('Chapter 8x Army Editor', 'FE6/Chapter8xArmyEditor'),
  getItem('Chapter 9 Armory Editor', 'FE6/Chapter9ArmoryEditor'),
  getItem('Chapter 9 Army Editor', 'FE6/Chapter9ArmyEditor'),
  getItem('Chapter 9 Shop Events', 'FE6/Chapter9ShopEvents'),
  getItem('Chapter 9 Vendor Editor', 'FE6/Chapter9VendorEditor'),
  getItem('Chapter Data Editor (FE6) -', 'FE6/ChapterDataEditorFE6'),
  getItem('Chapter Trial Map 1 Army Editor', 'FE6/ChapterTrialMap1ArmyEditor'),
  getItem('Chapter Trial Map 2 Army Editor', 'FE6/ChapterTrialMap2ArmyEditor'),
  getItem('Chapter Trial Map 3 Army Editor', 'FE6/ChapterTrialMap3ArmyEditor'),
  getItem('Chapter Trial Map 4 Army Editor', 'FE6/ChapterTrialMap4ArmyEditor'),
  getItem('Chapter Trial Map 5 Army Editor', 'FE6/ChapterTrialMap5ArmyEditor'),
  getItem('Custom Shop Editor', 'FE6/CustomShopEditor'),
  getItem('FE 6 Crit bonus editor', 'FE6/Critbonuseditor'),
  getItem('FE 6 Event Table References', 'FE6/EventTableReferences'),
  getItem('FE6 Battle Palette Reference', 'FE6/BattlePaletteReference'),
  getItem('FE6 Character Editor', 'FE6/CharacterEditor'),
  getItem('FE6 Class Editor', 'FE6/ClassEditor'),
  getItem('FE6 Custom Battle Animation Editor', 'FE6/CustomBattleAnimationEditor'),
  getItem('FE6 Custom Promotion Pointer Editor', 'FE6/CustomPromotionPointerEditor'),
  getItem('FE6 Death quote editor', 'FE6/Deathquoteeditor'),
  getItem('FE6 Enemy boss battle quote editor', 'FE6/Enemybossbattlequoteeditor'),
  getItem('FE6 Item Editor', 'FE6/ItemEditor'),
  getItem('FE6 Portrait Editor', 'FE6/PortraitEditor'),
  getItem('FE6 Promotion Item Editor', 'FE6/PromotionItemEditor'),
  getItem('FE6 Promotion level editor', 'FE6/Promotionleveleditor'),
  getItem('FE6 Sound Room Editor', 'FE6/SoundRoomEditor'),
  getItem('FE6 Spell Association Editor', 'FE6/SpellAssociationEditor'),
  getItem('FE6 Support Editor,', 'FE6/SupportEditor'),
  getItem('FE6 Triangle attack quote editor', 'FE6/Triangleattackquoteeditor'),
  getItem('Final Chapter Army Editor', 'FE6/FinalChapterArmyEditor'),
  getItem('Level Cap Editor', 'FE6/LevelCapEditor'),
  getItem('Support bonus editor', 'FE6/Supportbonuseditor'),
  getItem('Trial Map Characters Army Editor', 'FE6/TrialMapCharactersArmyEditor'),
  getItem('Tutorial Army Editor', 'FE6/TutorialArmyEditor'),
]);

export default FE6Items;
